import React from "react";
import Button from "./Button";
import { useStateContext } from "../contexts/ContextProvider";
import ImageUploader from "./ImageUploader";

const EditPhotosForm = (props) => {
  const { room, setRoom } = props;
  const { handleModal } = useStateContext();
  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      <div className="grid justify-items-center">
        <ImageUploader
          stateObject={room}
          setStateObject={setRoom}
          name="rooms"
        />
      </div>
      <div className="flex justify-center fixed bottom-0 w-full my-10">
        {/* <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Close"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("editPhotos")}
        /> */}
        <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Done"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("editPhotos")}
        />
      </div>
    </div>
  );
};

export default EditPhotosForm;
